import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Moment from "react-moment";
import moment from "moment";
import ReactLoading from "react-loading";
import TablePagination from "@mui/material/TablePagination";
import { Modal, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import Left_panel from "../Left_panel";
import Sub_header from "../Sub_header";
import Shipment_detail from "./Shipment_detail";
import exportValue from "../../apiconfig";
import "../../components/loader.css";
import Return_shipment_detail from "./Return_shipment_detail";
import Return_order_detail from "./Return_order_detail";

const Return_list = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const ordertype = searchParams.get("type") || "1";

  const adminData = (() => {
    try {
      return JSON.parse(localStorage.getItem("admin_login") || "{}");
    } catch (error) {
      return {};
    }
  })();

  // ============================================================
  // BASIC STATE
  // ============================================================

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [shipments, setShipments] = useState([]);

  const [totalCount, setTotalCount] = useState(0);

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(100);

  // ============================================================
  // TAB
  // ============================================================

  const [activeTab, setActiveTab] = useState("reverse_orders");

  // ============================================================
  // SEARCH
  // ============================================================

  const [searchValue, setSearchValue] = useState("");

  // ============================================================
  // CUSTOMER
  // ============================================================

  const [customerText, setCustomerText] = useState("");

  const [customerSuggestions, setCustomerSuggestions] = useState([]);

  const [customers, setCustomers] = useState([]);

  const [customerId, setCustomerId] = useState("");
  const [selectedOrderNumber, setSelectedOrderNumber] = useState(null);
  console.log("selectedOrderNumber ==", selectedOrderNumber);

  const customerInputRef = useRef(null);

  // ============================================================
  // DATE
  // ============================================================

  const [date, setDate] = useState({
    from_date: moment().subtract(30, "days").format("YYYY-MM-DD"),

    to_date: moment().format("YYYY-MM-DD"),
  });

  // ============================================================
  // FILTERS
  // ============================================================

  const [filters, setFilters] = useState({
    status: "",
    qc: "",
    qc_result: "",
  });

  // ============================================================
  // WAREHOUSE / CARRIER
  // ============================================================

  const [warehouse, setWarehouse] = useState([]);

  const [shippingCarriers, setShippingCarriers] = useState([]);

  const [selectedWarehouses, setSelectedWarehouses] = useState([]);

  const [selectedCarriers, setSelectedCarriers] = useState([]);

  const [warehouseSearch, setWarehouseSearch] = useState("");

  // ============================================================
  // FILTER DROPDOWN
  // ============================================================

  const [filterOpen, setFilterOpen] = useState(false);

  // ============================================================
  // SHIPMENT DETAIL
  // ============================================================

  const [showCanvas, setShowCanvas] = useState(false);

  const [selectedShipmentId, setSelectedShipmentId] = useState(null);

  // ============================================================
  // QC IMAGE MODAL
  // ============================================================

  const [showQcImageModal, setShowQcImageModal] = useState(false);

  const [selectedQcImages, setSelectedQcImages] = useState([]);

  // ============================================================
  // API
  // ============================================================

  const apiUrl = `${exportValue.host}/${exportValue.version}/${exportValue.api}`;

  // ============================================================
  // TAB CONFIGURATION
  // ============================================================

  const tabs = [
    {
      key: "reverse_orders",
      label: "Reverse Orders",
    },
    {
      key: "pickup_scheduled",
      label: "Pickup Scheduled",
    },
    {
      key: "in_transit",
      label: "In-transit",
    },
    {
      key: "out_for_delivery",
      label: "Out for Delivery",
    },
    {
      key: "returned",
      label: "Returned",
    },
    {
      key: "cancelled",
      label: "Cancelled",
    },
    {
      key: "all_shipments",
      label: "All Shipments",
    },
  ];

  const tabStatusMap = {
    pickup_scheduled: [9],

    in_transit: [3],

    out_for_delivery: [4],

    returned: [5],

    cancelled: [6],
  };

  // ============================================================
  // STATUS LABEL
  // ============================================================

  const statusMap = {
    0: ["Pending", "pickup_awit", "fa-clock-o"],

    1: ["Pickup Awaited", "pickup_awit", "fa-clock-o"],

    2: ["Picked Up", "pickedup", "fa-check"],

    3: ["In Transit", "in_transit", "fa-truck"],

    4: ["Out For Delivery", "out_for_delivery", "fa-truck"],

    5: ["Returned", "returned", "fa-check"],

    6: ["Cancelled", "cancelled", "fa-times"],

    7: ["Failed", "pickup_awit", "fa-times"],

    8: ["NDR", "ndr", "fa-exclamation"],

    9: ["Pickup Scheduled", "pickup_sechdls", "fa-calendar-o"],

    10: ["RTO", "pickup_awit", "fa-clock-o"],

    15: ["Booked", "pickup_awit", "fa-clock-o"],

    16: ["RTO Delivered", "pickup_awit", "fa-check"],

    17: ["Pickup Failed", "pickup_awit", "fa-times"],

    19: ["RTO In Transit", "pickup_awit", "fa-truck"],

    20: ["Lost", "pickup_awit", "fa-times"],
  };

  const getStatus = (status) => {
    const current = statusMap[status] || [
      "Not Available",
      "pickup_awit",
      "fa-clock-o",
    ];

    return (
      <span className={`status ${current[1]}`}>
        <i className={`fa ${current[2]}`} aria-hidden="true"></i> {current[0]}
      </span>
    );
  };

  // ============================================================
  // GET AWB
  // ============================================================

  const getAwb = (item) =>
    item?.carrier_type === "B2B"
      ? item?.lrnum || item?.shipment_id || ""
      : item?.carrier_tracking_number || item?.shipment_id || "";

  // ============================================================
  // QC
  // ============================================================

  const isQcApplicable = (item) => {
    return (
      item?.qc_applicable === true ||
      item?.qc_applicable === 1 ||
      String(item?.qc_applicable).toLowerCase() === "true" ||
      String(item?.qc_applicable) === "1"
    );
  };

  const renderQc = (item) => {
    return isQcApplicable(item) ? (
      <span className="badge rounded-pill bg-success">QC Applicable</span>
    ) : (
      <span className="badge rounded-pill bg-warning text-dark">
        QC Not Applicable
      </span>
    );
  };

  const renderQcResult = (item) => {
    const value =
      item?.qc_status ??
      item?.qc_result ??
      item?.qc_result_status ??
      item?.qc_details?.status ??
      item?.qc_details?.result ??
      item?.qcDetails?.status ??
      item?.qcDetails?.result;

    if (
      value === true ||
      value === 1 ||
      String(value).toLowerCase() === "1" ||
      ["pass", "passed", "success"].includes(String(value).toLowerCase())
    ) {
      return <span className="badge rounded-pill bg-success">QC Pass</span>;
    }

    if (
      value === false ||
      value === 0 ||
      String(value).toLowerCase() === "0" ||
      ["fail", "failed", "rejected"].includes(String(value).toLowerCase())
    ) {
      return <span className="badge rounded-pill bg-danger">QC Fail</span>;
    }

    return <span className="text-muted">-</span>;
  };

  // ============================================================
  // REVERSE SENDER
  //
  // Reverse shipment:
  // Sender = Original Customer
  // ============================================================

  const getReverseSender = (item) => {
    const sender = Array.isArray(item?.sender)
      ? item.sender[0] || {}
      : item?.sender || {};

    return {
      name: sender?.name || item?.sender_name || "",

      mobile: sender?.mobile || item?.sender_mobile || "",

      email: sender?.email || item?.sender_email || "",

      address: sender?.address || item?.sender_address || "",

      city: sender?.city || item?.sender_city || "",

      state: sender?.state || item?.sender_state_name || "",

      pincode: sender?.pincode || item?.sender_postal_code || "",
    };
  };

  // ============================================================
  // REVERSE RECEIVER
  //
  // Reverse shipment:
  // Receiver = Return Warehouse
  // ============================================================

  const getReverseReceiver = (item) => {
    const receiver = Array.isArray(item?.receiver)
      ? item.receiver[0] || {}
      : item?.receiver || {};

    return {
      name: receiver?.name || item?.receiver_name || "",

      mobile: receiver?.mobile || item?.receiver_mobile || "",

      email: receiver?.email || item?.receiver_email || "",

      address: receiver?.address || item?.receiver_address || "",

      city: receiver?.city || item?.receiver_city || "",

      state: receiver?.state || item?.receiver_state_name || "",

      pincode: receiver?.pincode || item?.receiver_postal_code || "",
    };
  };

  // ============================================================
  // PRODUCTS
  // ============================================================

  const getReturnProducts = (item) => {
    if (Array.isArray(item?.items) && item.items.length > 0) {
      return item.items;
    }

    if (
      Array.isArray(item?.product_details) &&
      item.product_details.length > 0
    ) {
      return item.product_details;
    }

    return [];
  };

  const getProductName = (item) => {
    const products = getReturnProducts(item);

    return products
      .map(
        (product) =>
          product?.item_name ||
          product?.shipment_content ||
          product?.product_name ||
          product?.name ||
          ""
      )
      .filter(Boolean)
      .join(", ");
  };

  const getProductSku = (item) => {
    const products = getReturnProducts(item);

    return products
      .map(
        (product) =>
          product?.sku ||
          product?.item_sku ||
          product?.sku_id ||
          product?.product_id ||
          ""
      )
      .filter(Boolean)
      .join(", ");
  };

  const getProductQuantity = (item) => {
    const products = getReturnProducts(item);

    return products.reduce(
      (total, product) =>
        total +
        Number(
          product?.item_quantity || product?.quantity || product?.qty || 0
        ),
      0
    );
  };

  // ============================================================
  // RETURN REASON
  // ============================================================

  const getReturnReason = (item) => {
    return (
      item?.return_reason ||
      item?.return?.reason ||
      item?.return_reason_name ||
      "-"
    );
  };

  // ============================================================
  // QC IMAGES
  // ============================================================

  const safeArray = (value) => {
    return Array.isArray(value) ? value : [];
  };

  const getQcImages = (item) => {
    const images =
      safeArray(item?.qc_images).length > 0
        ? safeArray(item.qc_images)
        : safeArray(item?.qc_details?.images);

    return images;
  };
  const renderQcImages = (item) => {
    const images =
      safeArray(item?.qc_images).length > 0
        ? safeArray(item.qc_images)
        : safeArray(item?.qc_details?.images);

    if (!images.length) {
      return <span className="text-muted">—</span>;
    }

    const getImageUrl = (image) => {
      const raw =
        typeof image === "string"
          ? image
          : image?.url ||
            image?.image_url ||
            image?.path ||
            image?.imageUrl ||
            "";

      if (!raw) {
        return "";
      }

      if (/^https?:\/\//i.test(raw)) {
        return raw;
      }

      return `https://cdn.thejetpost.in/${String(raw).replace(/^\/+/, "")}`;
    };

    return (
      <div className="d-flex flex-wrap gap-1">
        {images.slice(0, 4).map((image, index) => {
          const url = getImageUrl(image);

          if (!url) {
            return null;
          }

          return (
            <a
              key={image?._id || image?.index || index}
              href={url}
              target="_blank"
              rel="noreferrer"
              title={`QC Image ${index + 1}`}
            >
              <img
                src={url}
                alt={`QC ${index + 1}`}
                style={{
                  width: "42px",
                  height: "42px",
                  objectFit: "cover",
                  borderRadius: "6px",
                  border: "1px solid #dee2e6",
                }}
              />
            </a>
          );
        })}
      </div>
    );
  };

  const openQcImages = (item) => {
    const images = getQcImages(item);

    if (!images.length) {
      return;
    }

    setSelectedQcImages(images);

    setShowQcImageModal(true);
  };

  // ============================================================
  // REQUEST DATA
  // ============================================================

  const getRequestData = (requestedPage = 0) => {
    const data = {
      find: searchValue.trim(),

      indexValue: requestedPage,

      limit: Number(rowsPerPage),

      customer_id: customerId || "",

      carrier_type: ordertype == 1 ? "B2C" : "B2B",

      moving_type: "Reverse",

      search_with: "all",

      from_date: date.from_date,

      to_date: date.to_date,

      warehouse: selectedWarehouses,

      shipping_carrier: selectedCarriers,

      tab: activeTab,
    };

    // ----------------------------------------------------------
    // TAB STATUS
    // ----------------------------------------------------------

    if (activeTab !== "reverse_orders" && activeTab !== "all_shipments") {
      data.status = tabStatusMap[activeTab] || [];
    }

    // ----------------------------------------------------------
    // MANUAL STATUS FILTER
    // ----------------------------------------------------------

    if (filters.status !== "") {
      data.status = [Number(filters.status)];
    }

    // ----------------------------------------------------------
    // QC
    // ----------------------------------------------------------

    if (filters.qc !== "") {
      data.qc = filters.qc;
    }

    // ----------------------------------------------------------
    // QC RESULT
    // ----------------------------------------------------------

    if (filters.qc_result !== "") {
      data.qc_result = filters.qc_result;
    }

    return data;
  };

  // ============================================================
  // FETCH RETURN SHIPMENTS
  // ============================================================

  const getReturnShipments = async (requestedPage = 0) => {
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${apiUrl}/return_shipment_list`,
        getRequestData(requestedPage),
        {
          headers: exportValue.headers,
        }
      );

      const output = Array.isArray(response?.data?.output)
        ? response.data.output
        : [];

      const count = Number(response?.data?.dataCount || 0);

      setShipments(output);

      setTotalCount(count);

      setPage(requestedPage);
    } catch (error) {
      console.error("return_shipment_list error:", error);

      setShipments([]);

      setTotalCount(0);

      Swal.fire({
        icon: "error",
        title: "Unable to load",
        text: "Unable to load return shipments.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // ============================================================
  // CUSTOMER LIST
  // ============================================================

  const loadCustomers = async () => {
    try {
      const response = await axios.post(
        `${apiUrl}/customer_profile`,
        {
          admin_type: adminData.admin_type,

          admin_id: adminData.admin_id,
        },
        {
          headers: exportValue.headers,
        }
      );

      setCustomers(
        Array.isArray(response?.data?.output) ? response.data.output : []
      );
    } catch (error) {
      console.error("customer_profile error:", error);
    }
  };

  // ============================================================
  // WAREHOUSE
  // ============================================================

  const getWarehouse = async () => {
    try {
      const response = await axios.post(
        `${apiUrl}/getAllWarehouse`,
        {},
        {
          headers: exportValue.headers,
        }
      );

      if (response?.data?.status === true) {
        setWarehouse(response.data.output || []);
      } else {
        setWarehouse([]);
      }
    } catch (error) {
      console.error("getWarehouse error:", error);

      setWarehouse([]);
    }
  };

  // ============================================================
  // SHIPPING CARRIERS
  // ============================================================

  const getShippingCarriers = async () => {
    try {
      const response = await axios.post(
        `${apiUrl}/all_product_list`,
        {
          mode: "Domestic",
          type: "Reverse",
        },
        {
          headers: exportValue.headers,
        }
      );

      setShippingCarriers(response?.data?.output || []);
    } catch (error) {
      console.error("getShippingCarriers error:", error);

      setShippingCarriers([]);
    }
  };

  // ============================================================
  // INITIAL LOAD
  // ============================================================

  useEffect(() => {
    loadCustomers();

    getWarehouse();

    getShippingCarriers();
  }, []);

  useEffect(() => {
    getReturnShipments(0);
  }, [rowsPerPage, activeTab]);

  // ============================================================
  // CUSTOMER SEARCH
  // ============================================================

  const handleCustomerChange = (event) => {
    const value = event.target.value;

    setCustomerText(value);

    if (!value.trim()) {
      setCustomerId("");

      setCustomerSuggestions([]);

      return;
    }

    const search = value.trim().toLowerCase();

    const suggestions = customers.filter((item) => {
      const fullName = String(item?.full_name || "").toLowerCase();

      const email = String(item?.email || "").toLowerCase();

      const jpId = String(item?.jp_id || "").toLowerCase();

      return (
        fullName.includes(search) ||
        email.includes(search) ||
        jpId.includes(search)
      );
    });

    setCustomerSuggestions(suggestions.slice(0, 10));
  };

  const selectCustomer = (customer) => {
    setCustomerText(customer?.full_name || customer?.jp_id || "");

    setCustomerId(customer?.customer_id || "");

    setCustomerSuggestions([]);
  };

  // ============================================================
  // SEARCH
  // ============================================================

  const handleSearch = () => {
    getReturnShipments(0);
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // ============================================================
  // WAREHOUSE FILTER
  // ============================================================

  const handleWarehouseChange = (event, warehouseId) => {
    const id = String(warehouseId);

    setSelectedWarehouses((prev) => {
      if (event.target.checked) {
        return prev.includes(id) ? prev : [...prev, id];
      }

      return prev.filter((item) => item !== id);
    });
  };

  // ============================================================
  // CARRIER FILTER
  // ============================================================

  const handleCarrierChange = (event, productId) => {
    const id = String(productId);

    setSelectedCarriers((prev) => {
      if (event.target.checked) {
        return prev.includes(id) ? prev : [...prev, id];
      }

      return prev.filter((item) => item !== id);
    });
  };

  // ============================================================
  // FILTERED WAREHOUSES
  // ============================================================

  const filteredWarehouses = warehouse.filter((item) => {
    const search = warehouseSearch.trim().toLowerCase();

    if (!search) {
      return true;
    }

    const warehouseName =
      item?.warehouse_name ||
      item?.name ||
      item?.address ||
      item?.warehouse_address ||
      "";

    return String(warehouseName).toLowerCase().includes(search);
  });

  // ============================================================
  // RESET FILTERS
  // ============================================================

  const resetFilters = () => {
    setSearchValue("");

    setCustomerText("");

    setCustomerId("");

    setCustomerSuggestions([]);

    setSelectedWarehouses([]);

    setSelectedCarriers([]);

    setWarehouseSearch("");

    setDate({
      from_date: moment().subtract(30, "days").format("YYYY-MM-DD"),

      to_date: moment().format("YYYY-MM-DD"),
    });

    setFilters({
      status: "",
      qc: "",
      qc_result: "",
    });

    setFilterOpen(false);

    setTimeout(() => {
      getReturnShipments(0);
    }, 0);
  };

  // ============================================================
  // OPEN SHIPMENT
  // ============================================================

  const openShipment = (item) => {
    if (activeTab === "reverse_orders") {
      if (!item?._id) {
        Swal.fire("Error", "Order number not found.", "error");
        return;
      }

      setSelectedOrderNumber(item._id);
      setSelectedShipmentId(null);
    } else {
      const shipmentId = item?.shipment_id || item?._id;

      if (!shipmentId) return;

      setSelectedShipmentId(shipmentId);
      setSelectedOrderNumber(null);
    }

    setShowCanvas(true);
  };

  // ============================================================
  // COPY
  // ============================================================

  const copyToClipboard = (value) => {
    if (!value) {
      return;
    }

    navigator.clipboard?.writeText(String(value));
  };

  // ============================================================
  // STATUS UPDATE
  // ============================================================

  const status_update = async (shipmentId) => {
    try {
      const response = await axios.post(
        `${exportValue.host}/${exportValue.version}/${exportValue.api}/shipment_tracking`,
        {
          trackingNumber: shipmentId,
        },
        {
          headers: exportValue.headers,
        }
      );

      if (response?.data?.message === "success") {
        Swal.fire("Success!", "Status Updated Successfully!", "success");

        getReturnShipments(page);
      } else {
        Swal.fire("Unsuccessful!", "Something Went Wrong!", "error");
      }
    } catch (error) {
      console.error(error);

      Swal.fire("Unsuccessful!", "Something Went Wrong!", "error");
    }
  };

  // ============================================================
  // TAB CHANGE
  // ============================================================

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    setPage(0);
  };

  // ============================================================
  // PAGE CHANGE
  // ============================================================

  const handlePageChange = (event, newPage) => {
    getReturnShipments(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));

    setPage(0);
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div>
      <Left_panel
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen((prev) => !prev)}
      />

      <section className="home-section">
        <Sub_header />

        <section className="mt-3 px-3">
          {/* ==================================================
              PAGE HEADER
          ================================================== */}

          <div className="d-flex align-items-center justify-content-between mb-3">
            <div>
              <h4 className="mb-1 fw-bold">Returns Management</h4>

              <span className="badge bg-light text-primary border">
                Admin Panel
              </span>
            </div>
          </div>

          {/* ==================================================
              TABS
          ================================================== */}

          <div
            className="card border-0 shadow-sm mb-3"
            style={{
              borderRadius: 8,
            }}
          >
            <div
              className="d-flex overflow-auto"
              style={{
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => handleTabChange(tab.key)}
                  style={{
                    border: "0",
                    background: "transparent",

                    padding: "15px 22px",

                    whiteSpace: "nowrap",

                    fontWeight: activeTab === tab.key ? 600 : 500,

                    color: activeTab === tab.key ? "#3526d8" : "#334155",

                    borderBottom:
                      activeTab === tab.key
                        ? "3px solid #3526d8"
                        : "3px solid transparent",
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* ==================================================
              SEARCH / FILTER BAR
          ================================================== */}

          <div
            className="card border-0 shadow-sm mb-3"
            style={{
              borderRadius: 8,
            }}
          >
            <div className="card-body">
              <div className="row g-2 align-items-center">
                {/* SEARCH */}

                <div className="col-12 col-xl-4">
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="fa fa-search"></i>
                    </span>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search AWB, Order ID, Shipment ID, Mobile, Email, SKU"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      onKeyDown={handleSearchKeyDown}
                    />
                  </div>
                </div>

                {/* CUSTOMER */}

                <div className="col-12 col-xl-2 position-relative">
                  <input
                    ref={customerInputRef}
                    type="text"
                    className="form-control"
                    placeholder="Customer / JP ID"
                    value={customerText}
                    onChange={handleCustomerChange}
                    autoComplete="off"
                  />

                  {customerSuggestions.length > 0 && (
                    <ul
                      className="list-group position-absolute w-100 shadow"
                      style={{
                        zIndex: 2000,
                        maxHeight: 250,
                        overflowY: "auto",
                      }}
                    >
                      {customerSuggestions.map((customer, index) => (
                        <li
                          key={customer?.customer_id || index}
                          className="list-group-item list-group-item-action"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => selectCustomer(customer)}
                        >
                          <strong>{customer?.full_name}</strong>

                          <br />

                          <small>{customer?.email}</small>

                          <br />

                          <small>{customer?.jp_id}</small>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* DATE */}

                <div className="col-6 col-xl-2">
                  <input
                    type="date"
                    className="form-control"
                    value={date.from_date}
                    onChange={(e) =>
                      setDate((prev) => ({
                        ...prev,
                        from_date: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="col-6 col-xl-2">
                  <input
                    type="date"
                    className="form-control"
                    value={date.to_date}
                    onChange={(e) =>
                      setDate((prev) => ({
                        ...prev,
                        to_date: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* SEARCH BUTTON */}

                <div className="col-6 col-xl-1">
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                </div>

                {/* MORE FILTER */}

                <div className="col-6 col-xl-1">
                  <div className="position-relative">
                    <button
                      type="button"
                      className="btn btn-outline-primary w-100"
                      onClick={() => setFilterOpen((prev) => !prev)}
                    >
                      <i className="fa fa-filter me-1"></i>
                      More
                    </button>

                    {filterOpen && (
                      <div
                        className="position-absolute bg-white border rounded shadow p-3"
                        style={{
                          right: 0,
                          top: "calc(100% + 8px)",
                          width: 360,
                          maxHeight: 650,
                          overflowY: "auto",
                          zIndex: 3000,
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="mb-0">More Filters</h6>

                          <button
                            type="button"
                            className="btn btn-link btn-sm text-danger"
                            onClick={resetFilters}
                          >
                            Reset
                          </button>
                        </div>

                        <hr />

                        {/* WAREHOUSE */}

                        <label className="form-label fw-bold">Warehouse</label>

                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          placeholder="Search warehouse..."
                          value={warehouseSearch}
                          onChange={(e) => setWarehouseSearch(e.target.value)}
                        />

                        <div
                          style={{
                            maxHeight: 180,
                            overflowY: "auto",
                          }}
                        >
                          {filteredWarehouses.length > 0 ? (
                            filteredWarehouses.map((item, index) => {
                              const warehouseId =
                                item?.address_id ||
                                item?.warehouse_id ||
                                item?._id;

                              const warehouseName =
                                item?.warehouse_name ||
                                item?.name ||
                                item?.address ||
                                item?.warehouse_address ||
                                warehouseId ||
                                "—";

                              return (
                                <div
                                  className="form-check mb-2"
                                  key={warehouseId || index}
                                >
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`warehouse-${warehouseId || index}`}
                                    checked={selectedWarehouses.includes(
                                      String(warehouseId)
                                    )}
                                    onChange={(e) =>
                                      handleWarehouseChange(e, warehouseId)
                                    }
                                  />

                                  <label
                                    className="form-check-label"
                                    htmlFor={`warehouse-${
                                      warehouseId || index
                                    }`}
                                  >
                                    {warehouseName}
                                  </label>
                                </div>
                              );
                            })
                          ) : (
                            <small className="text-muted">
                              No warehouse found.
                            </small>
                          )}
                        </div>

                        <hr />

                        {/* SHIPPING CARRIER */}

                        <label className="form-label fw-bold">
                          Shipping Carrier
                        </label>

                        <div
                          style={{
                            maxHeight: 180,
                            overflowY: "auto",
                          }}
                        >
                          {shippingCarriers.length > 0 ? (
                            shippingCarriers.map((carrier, index) => {
                              const productId = String(
                                carrier?.product_id || ""
                              );

                              return (
                                <div
                                  className="form-check mb-2"
                                  key={productId || index}
                                >
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`carrier-${productId || index}`}
                                    checked={selectedCarriers.includes(
                                      productId
                                    )}
                                    onChange={(e) =>
                                      handleCarrierChange(e, productId)
                                    }
                                  />

                                  <label
                                    className="form-check-label"
                                    htmlFor={`carrier-${productId || index}`}
                                  >
                                    {carrier?.product_name}
                                  </label>
                                </div>
                              );
                            })
                          ) : (
                            <small className="text-muted">
                              No shipping carriers available.
                            </small>
                          )}
                        </div>

                        <hr />

                        {/* STATUS */}

                        <label className="form-label fw-bold">
                          Tracking Status
                        </label>

                        <select
                          className="form-select form-select-sm"
                          value={filters.status}
                          onChange={(e) =>
                            setFilters((prev) => ({
                              ...prev,
                              status: e.target.value,
                            }))
                          }
                        >
                          <option value="">All Status</option>

                          {Object.entries(statusMap).map(([value, status]) => (
                            <option key={value} value={value}>
                              {status[0]}
                            </option>
                          ))}
                        </select>

                        <hr />

                        {/* QC */}

                        <label className="form-label fw-bold">
                          QC Applicable
                        </label>

                        {[
                          {
                            value: "",
                            label: "All",
                          },
                          {
                            value: "yes",
                            label: "QC Yes",
                          },
                          {
                            value: "no",
                            label: "QC No",
                          },
                        ].map((option) => (
                          <div
                            className="form-check"
                            key={option.value || "all"}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="return-qc"
                              checked={filters.qc === option.value}
                              onChange={() =>
                                setFilters((prev) => ({
                                  ...prev,
                                  qc: option.value,
                                }))
                              }
                            />

                            <label className="form-check-label">
                              {option.label}
                            </label>
                          </div>
                        ))}

                        <hr />

                        {/* QC RESULT */}

                        <label className="form-label fw-bold">QC Result</label>

                        {[
                          {
                            value: "",
                            label: "All",
                          },
                          {
                            value: "pass",
                            label: "QC Pass",
                          },
                          {
                            value: "fail",
                            label: "QC Fail",
                          },
                        ].map((option) => (
                          <div
                            className="form-check"
                            key={option.value || "all-result"}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="return-qc-result"
                              checked={filters.qc_result === option.value}
                              onChange={() =>
                                setFilters((prev) => ({
                                  ...prev,
                                  qc_result: option.value,
                                }))
                              }
                            />

                            <label className="form-check-label">
                              {option.label}
                            </label>
                          </div>
                        ))}

                        <button
                          type="button"
                          className="btn btn-primary w-100 mt-3"
                          onClick={() => {
                            setFilterOpen(false);

                            getReturnShipments(0);
                          }}
                        >
                          Apply Filters
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ==================================================
              TABLE
          ================================================== */}

          {isLoading ? (
            <div
              style={{
                backgroundColor: "#f1f5f9",

                minHeight: 500,

                position: "relative",

                display: "flex",

                alignItems: "center",

                justifyContent: "center",
              }}
            >
              <ReactLoading
                type="spin"
                color="#000000"
                height={70}
                width={70}
              />
            </div>
          ) : (
            <div
              className="card border-0 shadow-sm"
              style={{
                borderRadius: 8,
              }}
            >
              <div className="table-responsive">
                <table
                  className="table table-hover mb-0"
                  style={{
                    minWidth: "1800px",
                  }}
                >
                  <thead>
                    <tr>
                      <th>Order &amp; AWB #</th>

                      <th>Carrier</th>

                      <th>Shipping Fee</th>

                      <th>Status</th>

                      <th>Customer Details</th>

                      <th>Package Details</th>

                      <th>QC Applicable </th>

                      <th>Rider Details</th>

                      <th>Return Address</th>

                      <th>Return Reason</th>

                      <th>QC Images</th>
                      <th>FE Images</th>

                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {shipments.length > 0 ? (
                      shipments.map((item, index) => {
                        const shipmentId =
                          item?.shipment_id || item?._id || index;

                        const sender = getReverseSender(item);

                        const receiver = getReverseReceiver(item);

                        const productName = getProductName(item);

                        const productSku = getProductSku(item);

                        const productQty = getProductQuantity(item);

                        const qcImages = getQcImages(item);

                        return (
                          <tr key={shipmentId}>
                            {/* ====================================
                                  ORDER & AWB
                              ==================================== */}

                            <td
                              style={{
                                minWidth: 180,
                                verticalAlign: "top",
                              }}
                            >
                              <strong>
                                <a
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();

                                    openShipment(item);
                                  }}
                                  className="text-primary text-decoration-none"
                                >
                                  {item?.order_number || "-"}
                                </a>
                              </strong>

                              <br />

                              <small>
                                AWB: <span>{getAwb(item) || "-"}</span>
                                {getAwb(item) && (
                                  <button
                                    type="button"
                                    className="btn btn-link btn-sm p-0 ms-1"
                                    title="Copy AWB"
                                    onClick={() =>
                                      copyToClipboard(getAwb(item))
                                    }
                                  >
                                    <i className="fa fa-clone"></i>
                                  </button>
                                )}
                              </small>

                              <br />

                              <small>Shipment ID: {item?.shipment_id}</small>

                              <br />

                              <small>JP ID: {item?.jp_id || "-"}</small>

                              <br />

                              <small className="text-muted">
                                {item?.created ? (
                                  <Moment format="MMM DD YYYY hh:mm A">
                                    {new Date(item.created * 1000)}
                                  </Moment>
                                ) : item?.order_created ? (
                                  <Moment format="MMM DD YYYY hh:mm A">
                                    {new Date(item.order_created * 1000)}
                                  </Moment>
                                ) : (
                                  ""
                                )}
                              </small>
                            </td>

                            {/* ====================================
                                  CARRIER
                              ==================================== */}

                            <td
                              style={{
                                verticalAlign: "top",
                              }}
                            >
                              {item?.carrier_image ? (
                                <img
                                  src={`https://cdn.thejetpost.in/images/${item.carrier_image}`}
                                  alt="carrier"
                                  style={{
                                    maxWidth: 90,
                                    maxHeight: 45,
                                    objectFit: "contain",
                                  }}
                                />
                              ) : (
                                <strong>
                                  {item?.service_provider ||
                                    item?.carrier_name ||
                                    item?.carrier_id ||
                                    "-"}
                                </strong>
                              )}
                            </td>

                            {/* ====================================
                                  SHIPPING FEE
                              ==================================== */}

                            <td
                              style={{
                                verticalAlign: "top",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <strong>
                                ₹
                                {Number(
                                  item?.final_amount ?? item?.total_amount ?? 0
                                ).toFixed(2)}
                              </strong>
                            </td>

                            {/* ====================================
                                  STATUS
                              ==================================== */}

                            <td
                              style={{
                                verticalAlign: "top",
                              }}
                            >
                              {getStatus(item?.status)}
                            </td>

                            {/* ====================================
                                  CUSTOMER DETAILS
                                  Reverse Sender
                              ==================================== */}

                            <td
                              style={{
                                minWidth: 220,
                                verticalAlign: "top",
                              }}
                            >
                              <strong>{receiver?.name || "-"}</strong>

                              <br />

                              <small>{receiver?.mobile || "-"}</small>

                              <br />

                              {receiver?.email && (
                                <>
                                  <small>{receiver.email}</small>

                                  <br />
                                </>
                              )}

                              <small>{receiver?.address}</small>

                              <br />

                              <small>
                                {[
                                  receiver?.city,
                                  receiver?.state,
                                  receiver?.pincode,
                                ]
                                  .filter(Boolean)
                                  .join(", ")}
                              </small>
                            </td>

                            {/* ====================================
                                  PACKAGE DETAILS
                              ==================================== */}

                            <td
                              style={{
                                minWidth: 220,
                                verticalAlign: "top",
                              }}
                            >
                              <div>
                                <strong>Product:</strong> {productName || "-"}
                              </div>

                              <div className="mt-1">
                                <strong>SKU:</strong> {productSku || "-"}
                              </div>

                              <div className="mt-1">
                                <strong>Qty:</strong> {productQty || "-"}
                              </div>

                              <div className="mt-1">
                                Dead wt.: {item?.dead_weight ?? "-"} kg
                              </div>

                              <div>
                                Volumetric wt.: {item?.volumetric_weight ?? "-"}{" "}
                                kg
                              </div>

                              <div>
                                Size: {item?.length ?? "-"} ×{" "}
                                {item?.width ?? "-"} × {item?.height ?? "-"} cm
                              </div>
                            </td>

                            {/* ====================================
                                  PACKOUT / QC
                              ==================================== */}

                            <td
                              style={{
                                minWidth: 160,
                                verticalAlign: "top",
                              }}
                            >
                              {renderQc(item)}

                              <div className="mt-2">{renderQcResult(item)}</div>
                            </td>

                            {/* ====================================
                                  RIDER
                              ==================================== */}

                            <td
                              style={{
                                minWidth: 150,
                                verticalAlign: "top",
                              }}
                            >
                              <strong>
                                {item?.rider_name || "Not Assigned"}
                              </strong>

                              <br />

                              <small>{item?.rider_mobile}</small>
                            </td>

                            {/* ====================================
                                  RETURN ADDRESS
                                  Reverse Receiver
                              ==================================== */}

                            <td
                              style={{
                                minWidth: 230,
                                verticalAlign: "top",
                              }}
                            >
                              <strong>{sender?.name || "-"}</strong>

                              <br />

                              <small>{sender?.address}</small>

                              <br />

                              <small>
                                {[sender?.city, sender?.state, sender?.pincode]
                                  .filter(Boolean)
                                  .join(", ")}
                              </small>

                              <br />

                              <small>{sender?.mobile}</small>
                            </td>

                            {/* ====================================
                                  RETURN REASON
                              ==================================== */}

                            <td
                              style={{
                                minWidth: 160,
                                verticalAlign: "top",
                              }}
                            >
                              {getReturnReason(item)}
                            </td>

                            {/* ====================================
                                  QC IMAGES
                              ==================================== */}

                            <td
                              style={{
                                minWidth: 110,
                                verticalAlign: "top",
                              }}
                            >
                              {renderQcImages(item)}
                            </td>
                            <td
                              style={{
                                minWidth: 110,
                                verticalAlign: "top",
                              }}
                            ></td>

                            {/* ====================================
                                  ACTIONS
                              ==================================== */}

                            <td
                              style={{
                                minWidth: 150,
                                verticalAlign: "top",
                              }}
                            >
                              {activeTab !== "reverse_orders" ? (
                                <div className="">
                                  <a
                                    type="button"
                                    className="btn btn-primary btn-sm "
                                    // data-bs-toggle="dropdown"
                                    href={
                                      "https://app.thejetpost.in/tracking/" +
                                      item.shipment_id
                                    }
                                    target="_blank"
                                  >
                                    Track Shipment
                                  </a>

                                  {/* <ul className="dropdown-menu">
                                  <li>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        openShipment(item?.shipment_id)
                                      }
                                    >
                                      View Shipment
                                    </button>
                                  </li>

                                  <li>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        status_update(getAwb(item))
                                      }
                                    >
                                      Update Status
                                    </button>
                                  </li>
                                </ul> */}
                                </div>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center py-5">
                          <div className="text-muted">
                            No return shipments found.
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* ==================================================
                  PAGINATION
              ================================================== */}

              <TablePagination
                component="div"
                rowsPerPageOptions={[
                  100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                ]}
                count={totalCount}
                page={page}
                onPageChange={handlePageChange}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            </div>
          )}

          {/* ==================================================
              SHIPMENT DETAIL OFFCANVAS
          ================================================== */}

          <div
            className={`offcanvas offcanvas-end ${showCanvas ? "show" : ""}`}
            style={{
              visibility: showCanvas ? "visible" : "hidden",

              width: "1000px",

              zIndex: 5000,
            }}
          >
            <div className="offcanvas-header">
              <h5 className="mb-0">Shipment Detail</h5>

              <button
                type="button"
                className="btn-close"
                onClick={() => setShowCanvas(false)}
              ></button>
            </div>

            <div className="offcanvas-body">
              {activeTab === "reverse_orders" && selectedOrderNumber ? (
                <Return_order_detail
                  key={`order-${selectedOrderNumber}`}
                  shipment_id={selectedOrderNumber}
                />
              ) : selectedShipmentId ? (
                <Return_shipment_detail
                  key={`shipment-${selectedShipmentId}`}
                  shipment_id={selectedShipmentId}
                />
              ) : null}
            </div>
          </div>

          {/* ==================================================
              QC IMAGE MODAL
          ================================================== */}

          <Modal
            show={showQcImageModal}
            onHide={() => setShowQcImageModal(false)}
            centered
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>QC Images</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {selectedQcImages.length > 0 ? (
                <div className="row g-3">
                  {selectedQcImages.map((image, index) => {
                    const imageUrl =
                      typeof image === "string"
                        ? image
                        : image?.url || image?.image_url || image?.src || "";

                    if (!imageUrl) {
                      return null;
                    }

                    return (
                      <div className="col-12 col-md-6" key={index}>
                        <div className="border rounded p-2">
                          <img
                            src={imageUrl}
                            alt={`QC ${index + 1}`}
                            className="img-fluid rounded"
                            style={{
                              width: "100%",
                              maxHeight: 400,
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-center text-muted py-4">
                  No QC images found.
                </div>
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowQcImageModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </section>
      </section>
    </div>
  );
};

export default Return_list;
